import React, { useEffect, useState } from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';

import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { MenuCredito } from 'components/menuCredito';
import CardElegirTarjeta from 'components/Card';

import { useCardsListT1 } from 'hooks/useCardsT1';
import { useIsMobile } from 'hooks/useIsMobile';
import { decodeStorage, removeStorage } from 'functions/storageBase64';

import Loading from 'components/Loading';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { Error500 } from 'components/Error/Error500';
import { ModalError } from 'components/Error/ErrorModal';

import { ElegirFormaPagoNew } from 'pages/Credito/3-PagarTarjeta/ElegirFormaPago'
import { CardPlanPagar } from 'pages/Credito/PagarPlanes/ModulosPagarPlanes';



export function ElegirTarjeta() {
    const history = useHistory();
    const { isMobile } = useIsMobile();
    const payCardRelation = decodeStorage('payCardRelation')
    
    
    const { cardsArray, updateArrayCards, loading, setLoading, errorCode, showModalErr, setShowModalErr, sectionActive, messageResponse } = useCardsListT1();
    // const [ loading, setLoading ] = useState(true);
    const [errorCodeCard,setErrorCodeCard] =useState(false);
    
    // console.log("que trae el nuevo error... ", errorCodeCard)
    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Choise Payment Card Credit-Page');
        window.ineum('meta', 'portal', 'Credito');
        removeStorage('clickToPay')
    }, [])

    useEffect(() => {
        if (!payCardRelation) {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`);
        }
    }, [])

    useEffect(() => {
        if (cardsArray) {
            if (cardsArray?.length === 0) {
                //history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/agregar-tarjeta-bancaria`);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }
    }, [cardsArray])


    const updatePage = () => {
        updateArrayCards(true);
    }

    let visa = '/img/logoFpVisa.png';
    let master = '/img/logoFpMaster.png';
    let amex = '/img/logoFpAmex.png';


    const handleAddCardBank = () => {
        // history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/agregar-tarjeta-bancaria`);
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-forma-pago`);
    };

    const [cardActive, setCadrActive] = useState();
    useEffect(() => { }, [cardActive])

    // valida pago y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);

        if (sectionActive === 'choiseCards') {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`);
        }
    }

    const planAsignado = decodeStorage('payCardRelation')

    useEffect(()=>{
        if(planAsignado){
            console.log('plan asignado relacion: ', planAsignado)
        }
    },[])

    return (
        <>
            {loading && <Loading />}

            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Elegir tarjeta"} type="backFull" />
                : null
            }

            <div className="container">

                <div className="contCards">

                    <MenuCredito />
                    {(errorCode >= 500 || errorCodeCard >= 500)
                        ? <Error500 />
                        : <div className="contArrayCards">
                            {isMobile
                                ? isMobile === 'desktop' &&
                                <h2 className="h1">Elige una forma de pago</h2>
                                : null
                            }

                            <div className="contFormasPago">
                                <div className="contentPayMethod">
                                    {errorCode != 412
                                        ?
                                            <div className='saveMethodPay'>
                                                {cardsArray &&
                                                    <h1 className="h2">Mis formas de pago guardadas</h1>
                                                }
                                                <div>
                                                    {cardsArray &&
                                                        cardsArray.map((singleCard, ind) =>
                                                            <CardElegirTarjeta
                                                                key={singleCard.token}
                                                                nombre={singleCard.nombre}
                                                                terminacion={singleCard.terminacion}
                                                                vencimiento={singleCard.expiracion_mes + '/' + singleCard.expiracion_anio}
                                                                tipoTarjeta={singleCard.marca}
                                                                logo={singleCard.marca === "visa" ? visa : singleCard.marca === "mastercard" ? master : amex}
                                                                id={singleCard.token}
                                                                dataCard={singleCard}
                                                                update={updatePage}
                                                                setCadrActive={setCadrActive}
                                                                cardActive={cardActive}
                                                                position={ind}
                                                                setLoading={setLoading}
                                                                setErrorCodeCard={setErrorCodeCard}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        : null
                                    }

                                    <ElegirFormaPagoNew
                                        errorCode={errorCode}
                                    />
                                </div>
                                <CardPlanPagar />
                            </div>
                        </div>
                    }
                </div>
            </div>

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete" />
                    : null
                : null
            }

            {showModalErr && (errorCode <= 499 || errorCode?.codMen <=499)  &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}